import Vue from 'vue'

const state = Vue.observable({
  stack: []
})

let uid = 1
let dialogCount = 0

function disableBodyScroll() {
  // 移动端需要用 position: fixed 而不是 overflow: hidden
  const scrollTop = window.scrollY || document.documentElement.scrollTop
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollTop}px`
  document.body.style.width = '100%'
  document.body.dataset.scrollY = scrollTop
}

function enableBodyScroll() {
  const scrollTop = parseInt(document.body.dataset.scrollY) || 0
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.width = ''
  document.body.removeAttribute('data-scroll-y')
  window.scrollTo(0, scrollTop)
}

function open(type, props = {}, options = {}) {
  dialogCount++
  if (dialogCount === 1) {
    disableBodyScroll()
  }

  return new Promise((resolve, reject) => {
    state.stack.push({
      id: uid++,
      type,
      props,
      options,
      resolve,
      reject
    })
  })
}

function close(id, payload, useReject = false) {
  const index = state.stack.findIndex(item => item.id === id)
  if (index === -1) return

  const current = state.stack[index]
  state.stack.splice(index, 1)

  dialogCount--
  if (dialogCount === 0) {
    enableBodyScroll()
  }

  if (useReject) {
    current.reject(payload)
    return
  }

  current.resolve(payload)
}

function closeTop(payload, useReject = false) {
  const top = state.stack[state.stack.length - 1]
  if (!top) return
  close(top.id, payload, useReject)
}

export default {
  install(VueInstance) {
    VueInstance.prototype.$dialog = {
      state,
      open,
      close,
      closeTop
    }
  }
}
